import { render, staticRenderFns } from "./StatsThroughputChart.vue?vue&type=template&id=1284a6ae"
import script from "./StatsThroughputChart.vue?vue&type=script&lang=js"
export * from "./StatsThroughputChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports